import styled, { css } from 'styled-components';
import { getFont, getLineHeight } from '@finect/tabular-utils/getFont';
import { textEllipsis } from '@finect/tabular-utils/textEllipsis';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-7y6lne-0"
})(["display:flex;align-items:center;justify-content:space-between;width:100%;padding:", " 9px;border-bottom:1px solid ", ";cursor:pointer;", ";", ";", ";&:hover{background-color:", ";}"], function (_ref) {
  var isCompact = _ref.isCompact;
  return isCompact ? '6px' : '9px';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiLL;
}, getFont(0), textEllipsis, function (_ref3) {
  var isCompact = _ref3.isCompact;
  return isCompact && css(["", ";height:", ";"], getFont(-1), getLineHeight(-1));
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.uiLL;
});
export var Content = styled.div.withConfig({
  displayName: "partials__Content",
  componentId: "sc-7y6lne-1"
})(["flex-shrink:1;max-width:100%;"]);
export var Subtitle = styled.div.withConfig({
  displayName: "partials__Subtitle",
  componentId: "sc-7y6lne-2"
})(["", ";color:", ";user-select:none;"], getFont(-1), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.fontL;
});
export var ResultName = styled.div.withConfig({
  displayName: "partials__ResultName",
  componentId: "sc-7y6lne-3"
})(["overflow:hidden;margin-right:9px;user-select:none;", ";", ";svg{margin-right:8px;vertical-align:middle;}small{", ";margin-right:8px;color:", ";}"], function (_ref6) {
  var isCompact = _ref6.isCompact;
  return !isCompact && css(["", ";white-space:nowrap;text-overflow:ellipsis;"], getFont(0));
}, function (_ref7) {
  var isCompact = _ref7.isCompact;
  return isCompact && css(["", ";"], getFont(-2));
}, getFont(-1), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.fontL;
});